var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconUnauthorized(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 208,
    height: 208,
    viewBox: "0 0 208 208",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "b",
    cx: 80,
    cy: 80,
    r: 80
  }), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "147.5%",
    height: "147.5%",
    x: "-23.8%",
    y: "-21.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 12
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowBlurOuter1",
    in2: "SourceAlpha",
    operator: "out",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0.164705882 0 0 0 0 0.239215686 0 0 0 0 0.298039216 0 0 0 0.15 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 20)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a)",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 80,
    cy: 80,
    r: 77,
    fill: "#FFF",
    stroke: "#E0294F",
    strokeLinejoin: "square",
    strokeWidth: 6
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E0294F",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105 114c-1.656 0-3 1.224-3 2.737v37.526c0 1.513 1.344 2.737 3 2.737s3-1.224 3-2.737v-37.526c0-1.511-1.344-2.737-3-2.737zM96.818 66.562a2.635 2.635 0 0 0 3.677-.851c.783-1.273.41-2.954-.836-3.756a7.024 7.024 0 0 1-2.223-2.291 7.401 7.401 0 0 1-.917-5.526 7.26 7.26 0 0 1 3.172-4.565 6.987 6.987 0 0 1 5.405-.934 7.126 7.126 0 0 1 4.47 3.24 7.448 7.448 0 0 1 .924 5.526 7.254 7.254 0 0 1-3.176 4.564c-1.248.8-1.626 2.478-.846 3.753a2.65 2.65 0 0 0 2.26 1.278c.484 0 .974-.134 1.413-.416 2.83-1.81 4.799-4.638 5.545-7.971a12.958 12.958 0 0 0-1.603-9.628c-1.768-2.883-4.535-4.89-7.793-5.657-3.256-.764-6.602-.183-9.433 1.63-2.83 1.816-4.795 4.646-5.536 7.963a12.887 12.887 0 0 0 1.592 9.626 12.378 12.378 0 0 0 3.905 4.015z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.198 152.085L120.2 112.177V78.526c4.03.797 7.082 4.346 7.082 8.598v22.04a2.74 2.74 0 0 0 2.743 2.738 2.74 2.74 0 0 0 2.743-2.737V87.124c0-7.852-6.404-14.243-14.275-14.245-.178 0-.35.02-.518.051a2.74 2.74 0 0 0-3.26 2.686v31.087L87.258 79.305c1.18-.59 2.494-.95 3.902-.95a2.74 2.74 0 0 0 2.742-2.737 2.74 2.74 0 0 0-2.742-2.737c-2.933 0-5.66.888-7.929 2.406L53.682 45.802a2.746 2.746 0 0 0-3.878 0 2.731 2.731 0 0 0 0 3.87L79.34 79.145a14.13 14.13 0 0 0-2.405 6.915 2.719 2.719 0 0 0-.053.534v22.57a2.74 2.74 0 0 0 2.743 2.738 2.74 2.74 0 0 0 2.743-2.737v-22.04c0-1.436.38-2.771.995-3.968L89 88.782c-.122.312-.196.65-.196 1.005v65.476A2.74 2.74 0 0 0 91.547 158a2.74 2.74 0 0 0 2.743-2.737V94.06l20.428 20.384v40.82a2.74 2.74 0 0 0 2.743 2.737 2.74 2.74 0 0 0 2.743-2.737v-35.346l36.114 36.038a2.737 2.737 0 0 0 1.94.8 2.737 2.737 0 0 0 1.94-4.67z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUnauthorized);
export default __webpack_public_path__ + "static/media/icon_unauthorized.0f0d3a5e412f65a7512c68a3dacdd038.svg";
export { ForwardRef as ReactComponent };